<template>
    <!-- Solution解决方案页面下通用： 数字Key + 标题 -->
    <div class="union-title-container">
        <div v-if="unionTitle.key" class="union-key">
            {{ formatedKey }}
        </div>
        <div class="union-title" v-html="$t(unionTitle.title)" />
        <div
            v-if="unionTitle.subTitle && typeof unionTitle.subTitle === 'string'"
            class="union-subtitle"
            v-html="$t(unionTitle.subTitle)"
        />
    </div>
</template>

<script lang="ts" setup>
    const props = defineProps<{
        unionTitle: UnionTitle;
    }>();

    const formatedKey = computed(() =>
        typeof props.unionTitle.key === 'number' ? `0${props.unionTitle.key}` : props.unionTitle.key,
    );

    onMounted(() => {
        addSlideInUp('.union-title-container ');
    });
</script>

<style lang="less" scoped>
    .union-title-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        color: #ffffff;
        font-family: Montserrat, 'HarmonyOS Sans SC';

        .union-key {
            width: fit-content;
            color: #0032ff;
            font-size: .convert(@font-size-title-xxl) [ @vw]; //96px
            font-weight: @font-weight-xl;

            color: #fff;
            font-size: .convert(@font-size-title-xxl) [ @vw];
            font-family: 'NeuePowerW05-Bold';
            font-weight: @font-weight-xl;
            line-height: @line-height-xs;
            @media (max-width: @screen-mobile-width) {
                font-size: .convert(@font-size-title-xs) [ @vw-mobile] !important; //36px
                // margin-bottom: .convert(10px) [ @vw-mobile] !important; //10px;
            }
        }

        .union-title {
            font-family: 'HarmonyOS Sans SC';
            width: fit-content;
            font-size: .convert(48px) [ @vw]; //48px
            line-height: 56px;
            text-align: center;
            margin-top: .convert(16px) [ @vw];
            @media (max-width: @screen-mobile-width) {
                font-size: .convert(@font-size-lg-ssm) [ @vw-mobile] !important; //16px
                margin-top: 10px;
            }
        }
        .union-subtitle {
            margin-top: .convert(40px) [ @vw];
            font-size: .convert(24px) [ @vw]; //24px
            font-weight: 400;
            font-family: 'HarmonyOS Sans SC';
            text-align: center;
            @media (max-width: @screen-mobile-width) {
                text-align: center;
                opacity: 0.6;
                font-size: .convert(@font-size-xm) [ @vw-mobile] !important; //12px
            }
        }
    }
    :lang(en) {
        .union-title-container {
            .union-title {
                line-height: 59px;
            }
        }
    }
</style>
